if (typeof localizationForm === 'undefined') {
    class LocalizationForm extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                // spec: specs/language-currency-linked-switch.md (FR-04, AC-10) — cada form lleva ahora
                // el input del otro campo (idioma ↔ mercado). Se excluye el enlazado para que el input
                // propio no dependa del orden en que aparezcan dentro del form.
                input: this.querySelector('input[name="locale_code"]:not([data-linked-input]), input[name="country_code"]:not([data-linked-input])'),
                button: this.querySelector('button'),
                panel: this.querySelector('ul'),
            };
            // this.elements.button.addEventListener('click', this.openSelector.bind(this));
            // this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
            this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    
            // document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    
        }
    
        onItemClick(event) {
            event.preventDefault();
            this.elements.input.value = event.currentTarget.dataset.value;
            // spec: specs/language-currency-linked-switch.md (FR-04, AC-11) — propaga el par mapeado
            // (en↔US, es↔CO) en el mismo submit. Sin par definido el input enlazado conserva el
            // contexto activo y el selector se comporta como antes del spec.
            // trim(): el valor sale de un {% case %} multilínea dentro de un atributo — un
            // whitespace de más ahí produciría country_code=" CO " y Shopify lo rechazaría.
            const linkedValue = (event.currentTarget.dataset.linkedValue || '').trim();
            const linkedInput = this.querySelector('input[data-linked-input]');
            if (linkedValue && linkedInput) linkedInput.value = linkedValue;
            this.querySelector('form')?.submit();
        }
    
        openSelector() {
            this.elements.button.focus();
            this.elements.panel.toggleAttribute('hidden');
            this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
        }
    
        closeSelector(event) {
            const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
            if (event.relatedTarget === null || shouldClose) {
                this.elements.button.setAttribute('aria-expanded', 'false');
                this.elements.panel.setAttribute('hidden', true);
            }
        }
    
        onBodyClickEvent(event){
            if ((!this.contains(event.target)) && ($(event.target).closest('[localization-form__select]').length === 0)){
                this.closeSelector(event);
            }
        }
    }
    
    customElements.define('localization-form', LocalizationForm);

    var localizationForm = LocalizationForm;
}